import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import './CovrButton.scss';

export default function CovrButton(props) {
  const loadingClass = props.loading ? "covr-button loading" : "covr-button";
  const buttonVariant = props.variantText ? 'text' : 'contained';
  return (
    <Button
      type="submit"
      variant={buttonVariant}
      color={props.color || "primary"}
      className={loadingClass}
      onClick={props.onClick || (() => ({}))}
      disabled={props.loading || props.disabled}
    >
      <span className="name">{props.name}</span>
    </Button>
  )
}

CovrButton.propTypes = {
  name: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.object.isRequired,
  ]),
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  variantText: PropTypes.bool,
  color: PropTypes.string,
}
